<div class="heading">
  <h1 class="span"><span translate>DG-DYNAMIC-INPUT-COMPONENT</span></h1>
  <a href="{{ doc_url }}">
    <mat-icon class="span" id="link">attachment</mat-icon>
  </a>
</div>
<div class="px-4 row">
  <div class="col-md-3">
    <mat-checkbox [(ngModel)]="showLabel">Show Label</mat-checkbox>
  </div>
  <div class="col-md-3">
    <mat-checkbox [(ngModel)]="mandatory" (change)="onMandatoryChange()">
      Mandatory
    </mat-checkbox>
  </div>
  <div class="col-md-3">
    <mat-checkbox
      [(ngModel)]="showDefaultValue"
      (change)="onShowDefaultValueChange()"
    >
      Show Default Value
    </mat-checkbox>
  </div>
  <div class="col-md-3">
    <button
      mat-raised-button
      color="primary"
      (click)="dgDynamicInputFormGroup?.reset()"
    >
      Reset Form
    </button>
  </div>
</div>
<div class="mt-5">
  <form [formGroup]="dgDynamicInputFormGroup" (ngSubmit)="onSubmit()">
    <button mat-raised-button color="primary">Submit</button>

    <div class="px-4 row" *ngFor="let data of inputData; index as i">
      <div class="my-2 col-md-4">
        <dg-dynamic-input
          [data]="data"
          [value]="data?.inputValue"
          [showLabel]="showLabel"
          [dataPropConfig]="inputDataPropConfig"
          [comboPropConfig]="comboPropConfig"
          [form]="dgDynamicInputFormGroup"
          (onChangeEvent)="onInputChange($event)"
          (onSearchClick)="onSearchClick()"
        >
          <!-- <ng-template #dgDynamicInputSuffixTemplate>
            <mat-icon
              class="cursor-pointer"
              matTooltip="asdf"
              (click)="clear(data)"
            >
              clear
            </mat-icon>
          </ng-template> -->
        </dg-dynamic-input>
      </div>
      <div class="ml-5 col-md-6 align-self-center bg-dark">
        <pre
          style="color: #00ff41; font-size: larger; font-family: monospace"
          [innerHTML]="getFormControlValue(data) | json"
        ></pre>
      </div>
    </div>
  </form>
</div>

<ng-template #dgDynamicInputSuffixTemplate let-data="data">
  <mat-icon class="cursor-pointer" matTooltip="asdf" (click)="clear(data)">
    clear
  </mat-icon>
</ng-template>
